import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { PaginatorState } from '../reducers/paginator.reducer';
import * as selectors from '../selectors/paginator.selectors';

@Injectable({
  providedIn: 'root',
})
export class PaginatorFacadeService extends FacadeService {
  constructor(public override store: Store<PaginatorState>) {
    super(store);
  }

  itemsPerPage$ = this.storeSelect(selectors.getItemsPerPage);
  itemsNumber$ = this.storeSelect(selectors.getItemsNumber);
  selectedSortField$ = this.storeSelect(selectors.getSelectedSortField);
  selectedOrder$ = this.storeSelect(selectors.getSelectedOrder);
  totalResultPages$ = this.storeSelect(selectors.getTotalResultPages);
  pageIndex$ = this.storeSelect(selectors.getPageIndex);
  sortFieldOptions$ = this.storeSelect(selectors.getSortFieldOptions);
  orderFieldOptions$ = this.storeSelect(selectors.getOrderFieldOptions);

  get itemsNumber() {
    return this.storeSnapshot(this.itemsNumber$);
  }

  get selectedOrder() {
    return this.storeSnapshot(this.selectedOrder$);
  }

  get selectedSortField() {
    return this.storeSnapshot(this.selectedSortField$);
  }

  get pageIndex() {
    return this.storeSnapshot(this.pageIndex$);
  }
}
